export default "__VITE_ASSET__YxRfuLHh__"